import api from "../../api.service";
import Swal from "sweetalert2";
import store from "../";
const state = {
    usersList: [],
    rolesList: [],
    userForm:{
        fullName:"",
        username:"",
        password:"",
        rolesIds:[]
    }
};
const getters = {
    usersList(state) {
        state.usersList.map((user) => {
            user.roles.map((role, index) => {
                switch(role) {
                    case 'Admin': user.roles[index] = 'المدير';
                    break;
                    case 'Shop': user.roles[index] = 'المشتركون';
                    break;
                    case 'Contact': user.roles[index] = 'التواصل';
                    break;
                    case 'Offer': user.roles[index] = 'العروض والإعلانات';
                    break;
                    case 'Subscription': user.roles[index] = 'الإشتراكات';
                    break;
                }   
            }) 
        })
        return state.usersList;
    },
    rolesList(state) {
        state.rolesList.map((role) => {
            switch(role.name) {
                case 'Admin': role.name = 'المدير';
                break;
                case 'Shop': role.name = 'المشتركون';
                break;
                case 'Contact': role.name = 'التواصل';
                break;
                case 'Offer': role.name = 'العروض والإعلانات';
                break;
                case 'Subscription': role.name = 'الإشتراكات';
                break;
            }
        })
        return state.rolesList
    },
    userForm(state) {
        return state.userForm;
    }
};
const mutations = {
    GET_USERS_ITEMS(state, payload) {
        console.log(payload);
        state.usersList = payload.users;
        state.rolesList = payload.rolesList;
        store.dispatch('setLoading', false);
    },
    GET_USER_DETAILS(state, payload) {
        if(payload >= 0){
            Object.assign(state.userForm, state.usersList[payload]);
        } else {
            Object.assign(state.userForm, {
                fullName:"",
                username:"",
                password:"",
                rolesIds:[]
            });
        }
        store.dispatch('setLoading', false);
    },
    ADD_USER_ITEMS(state, payload) {
        state.usersList.unshift(payload);
        Object.assign(state.userForm, {
            fullName:"",
            username:"",
            password:"",
            rolesIds:[]
        });
        store.dispatch('setLoading', false);
    },
    UPDATE_USER_ITEMS(state, payload) {
        let index = state.usersList.findIndex(item => item.id == payload.id);
        Object.assign(state.usersList[index], payload);
        Object.assign(state.userForm, {
            fullName:"",
            username:"",
            password:"",
            rolesIds:[]
        });
        store.dispatch('setLoading', false);
    },
    REMOVE_USER(state,payload) {
        const index = state.usersList.findIndex(
            item => item.id == payload.id);
        state.usersList.splice(index, 1);
        store.dispatch('setLoading', false);
        Swal.fire({
            title: "تم الحذف !",
            text: `تم حذف المستخدم ${payload.username} بنجاح .`,
            icon: "success",
            showConfirmButton: false,
            timer: 2000
        });
    }
};
const actions = {
    async fetchUsers(context) {
        const { data } = await api.query(`/api/Account/GetUsers`).then((data) => data);
        context.commit("GET_USERS_ITEMS", data);
    },
    async fetchUserDetails(context,payload)
    {
        context.commit("GET_USER_DETAILS", payload);
    },
    async createUser(context, payload) {
        store.dispatch('setLoading', true);
        const { data } = await api
            .post("/api/Account/CreateUser", {
                Id: payload.id,
                FullName: payload.fullName,
                Username: payload.username,
                Password: payload.password,
                RolesIds: payload.rolesIds
            })
            .then((data) => data);
           
        if (typeof data === 'string') {
            context.commit("ERROR_MESSAGE", data);
        } else {
            context.commit("ADD_USER_ITEMS", data);
        }
    },
    async updateUser(context, payload) {
        store.dispatch('setLoading', true);
        const { data } = await api
            .post("/api/Account/UpdateUser", {
                Id: payload.id,
                FullName: payload.fullName,
                Username: payload.username,
                Password: payload.password,
                RolesIds: payload.rolesIds
            })
            .then((data) => data);
         
        if (typeof data === 'string') {
            context.commit("ERROR_MESSAGE", data);
        } else {
            context.commit("UPDATE_USER_ITEMS", data);
        }
    },
    async removeUser(context, payload) {
        await api
            .delete(`/api/Account/RemoveUser?userId=${payload.id}`)
            .then(data => data);
        context.commit("REMOVE_USER", payload);
    },
    
};

const account = { state, getters, mutations, actions };

export default account;
